import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campBtReorder: FaireAdCampaignEntity = {
  token: "camp_bt_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_by_together",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 15000,
  startedRunningAt: "2025-02-13",
  segmentMetrics: {
    numReorderConversions: 1389,
    salesDollars: 1219000,
    totalAdsSpendDollars: 57921,
    returnOnAdSpend: 21.05,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
